import { Autocomplete, Button, CircularProgress, TextField } from '@mui/material'
import React, { useEffect, useMemo, useRef, useState } from 'react'
import * as Sentry from "@sentry/react";
import { fetchAllBaskets, getAllBanners, getFinalBannerTemplates } from '../../services/bannerServices'
import { bannerTemplates } from '../createBanner/bannerTemplates';
import { bucketDesigns } from '../createBucket/bucketTypes';
import { openPopup } from "../../stateManagement/actions/popupActions";
import { fetchClientConfig, getClientConfigDomainType, getConfigKeyValue } from '../../services/manageHomeScreenService';
import { retailerAppLayoutConfigObj } from './CreateBlockTypes';
import { fetchAllBuckets } from '../../services/manageBucketService';
import { Banner, BannerElement, BannerTemplate } from '../../types';
import { bucketDesignType } from '../manageBucket/ManageBucketTypes';
import BlockBannerSelection from './BlockBannerSelection';
import { defaultBlockConfig } from '../manageHomepage/ManageHomeScreenConfig';
import { defaultBannerTemplate } from '../createBanner/CreateBanner';
import { Loader } from '../../components/loader/Loader';
import { useLocation, useNavigate } from 'react-router-dom';
import { ConfirmationPopUp } from '../../components/popup/confirmationPopUp';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUpRightFromSquare, faCircleMinus, faCirclePlus, faEye, faGripLines, faPlus } from '@fortawesome/free-solid-svg-icons';
import { DragDropContext, Draggable, DropResult, Droppable } from 'react-beautiful-dnd';
import { BannerPreview } from '../../components/bannerPreview/BannerPreview';
import GenricMultiSelect from '../../components/Input/GenericMultiSelect';
import { OptionType } from '../manageHomepage/ManageHomePageTypes';
import { useSelector } from 'react-redux';
import store from '../../stateManagement/store';

export default function PromoBlock({ redirectToRef, blockState, handleParentDataSubmit, validateAllParentInputs, curBlockData, view, setIsChange, bannerBehaviourOptionValue, setBannerBehaviourOptionValue }: any) {
    const [banners, setBanners] = useState<Banner[]>([]);
    const [useBeta, setUseBeta] = useState<boolean>(false);
    const allBlocksRef = useRef<any[]>([]);
    const [compLoader, setCompLoader] = useState<boolean>(false);
    const [showLoader, setShowLoader] = useState<boolean>(false);
    const navigate = useNavigate();
    const [openCreateModal, setOpenCreateModal] = useState<boolean>(false);
    const [openSubmitModal, setOpenSubmitModal] = useState<boolean>(false);
    const clientConfigRef = useRef<any[]>([]);
    const currentRoute = (useLocation().pathname);
    const [openConfirmModal, setOpenConfirmModal] = useState<boolean>(false);
    // const locationState: createBucketNavigate = location.state as createBucketNavigate;
    const [bannerOptions, setBannerOptions] = useState<string[]>([]);
    const [selectedBanners, setSelectedBanners] = useState<string[]>([]);
    const needBasedBannersData = useRef<Banner[]>([]);
    const [currentBannerElements, setCurrentBannerElements] = useState<BannerElement[]>([]);
    const [openBannerPreview, setOpenBannerPreview] = useState<boolean>(false);
    const [openDeletConfirmModal, setOpenDeleteConfirmModal] = useState<boolean>(false);
    const targetBanner = useRef<Banner>();
    const deleteBanner = useRef<Banner>();
    const allBannersRef = useRef<Banner[] | null>(null);
    const savedRole:any = useSelector(() => store.getState().roleState.role)
    const handleSubmit = async () => {
        
        try {
            setShowLoader(true);
            let message = "";
            if (validateAllParentInputs) message = validateAllParentInputs();
            if (message !== "") {
                openPopup("Alert", message);
                setShowLoader(false);
                return;
            }
            let requestBody = {};
            const bannerIds = banners.map((bannerObj) => bannerObj.id);
            
            if (!curBlockData || curBlockData?.bannerVersion) {
                requestBody = { bannerIds,bannerVersion:"2.0"};
            }
            handleParentDataSubmit && await handleParentDataSubmit(requestBody);
            setShowLoader(false);
        } catch (err) {
            openPopup("Alert", "Some error occured")
        } finally {
            setShowLoader(false);
        }
    }
    useEffect(() => {
        async function getAndSetNeedBasedBanners() {
            setCompLoader(true);
            const clientconfig = await fetchClientConfig();
            let betaConfig = clientconfig.find((config: any) => {
                return config.domainType === "beta_configuration";
            })?.domainValues;
            const betaBlocks = betaConfig?.find((configObj: retailerAppLayoutConfigObj) => {
                return configObj.name === "homeScreenBlockWidget";
            })?.value ?? [];
            let useBeta = false;
            if (Array.isArray(betaBlocks) && betaBlocks.length > 0) {
                setUseBeta(true);
                debugger;
                useBeta = true;
            }
            const roleAppLayoutConfig = getClientConfigDomainType(clientconfig, `${savedRole?.id}_app_layout_configuration`);
            const blockConfig = useBeta ? betaBlocks : getConfigKeyValue(roleAppLayoutConfig, "homeScreenBlockWidget") ?? defaultBlockConfig[0].value;
            clientConfigRef.current = clientconfig;
            allBlocksRef.current = blockConfig;
            let prevMappedBanner: string[] = [];
            const blockBannerIds = curBlockData?.bannerIds
            
            const allBlocks = allBlocksRef.current;
            const bannerIdSet = new Set();
            allBlocks.forEach((blockObj: any) => {
                blockObj?.bannerIds?.forEach((id: string) => {
                    bannerIdSet.add(id);
                })
            })
            let allBanners: Banner[] | null = allBannersRef.current;
            if (!allBanners) {
                allBanners = await getAllBanners() as Banner[];
                allBannersRef.current = allBanners;
            }
            const templateFilteredBanners = allBanners.filter((banner: Banner) => {
                 return banner?.extendedAttributes?.resolution?.label === "1024 X 376";
            });
            const bannersNotLinkedToBlocks = templateFilteredBanners.filter(bannerObj => {
                return !bannerIdSet.has(bannerObj.id);
            })
            let finalBannerState: Banner[] = [];
            prevMappedBanner = bannersNotLinkedToBlocks.map((bannerObj) => bannerObj.bannerName);

            if (view === "edit" && blockBannerIds) {
                
                const prevSelectedBanners = blockBannerIds.map((bannerId: string) => {
                    return templateFilteredBanners.find((banner: Banner) => banner.id === bannerId);
                }).filter((banner: Banner | undefined) => banner !== undefined) as Banner[];

                finalBannerState = [...prevSelectedBanners, ...finalBannerState,];
                // props.setBanners(bannerState as Banner[]);
            }
            setBanners(finalBannerState as Banner[]);
            setBannerOptions(prevMappedBanner);
            needBasedBannersData.current = templateFilteredBanners;
            setCompLoader(false);
        }
        getAndSetNeedBasedBanners();
    }, []);
    function handleSelectBanners(selectedBannerOptions: string[]) {
        setSelectedBanners(selectedBannerOptions);
    }
    function handleAddBanners() {
        setIsChange(true)
        const newNeedBasedBanners = selectedBanners.map((bannerName: string) => {
            return needBasedBannersData.current.find((bannerObj: any) => bannerObj.bannerName === bannerName);
        });
        const newBannerState = [...banners, ...newNeedBasedBanners];
        setBanners(newBannerState as Banner[]);
        const newBannerOptions = bannerOptions.filter((bannerName: string) => {
            return !selectedBanners.find((selectedBannerName: string) => selectedBannerName === bannerName);
        })
        setSelectedBanners([]);
        setBannerOptions(newBannerOptions);
    }
    function handleDragOnEnd(result: DropResult) {
        if (result.destination !== null) {
            const items = Array.from(banners);
            const [reorderedItem] = items.splice(result.source.index, 1);
            if (result.destination)
                items.splice(result.destination.index, 0, reorderedItem);

            setBanners(items);
        }
    }
    function handleBannerRemove() {
        setIsChange(true)
        const targetBanner = deleteBanner.current
        if (targetBanner) {
            const newFilterdBanners = banners.filter((banner: Banner) => {
                return banner.bannerName !== targetBanner.bannerName;
            })
            setBanners(newFilterdBanners);
            setBannerOptions([targetBanner.bannerName, ...bannerOptions]);
        }
    }
    function handleEye(targetBanner: Banner) {
        setCurrentBannerElements(targetBanner.bannerElements);
        setOpenBannerPreview(true);
    }
    function navigateToEditBanner() {
        if (targetBanner.current) {
            const bannerData = { ...targetBanner.current, bannerTemplateType: bannerTemplates.find((bannerTemplate) => targetBanner.current?.bannerType === bannerTemplate.id)?.label };
            // setCurrentBanner(bannerData as bannerData);
            if (currentRoute.includes("/dashboard/")) {
                navigate("/dashboard/newManageBannerStudio/banner", {
                    state: {
                        isBucketEdit: true,
                        currentBanner: bannerData
                    }
                });
            } else {
                navigate("/manageBanner/banner", {
                    state: {
                        isBucketEdit: true,
                        currentBanner: bannerData
                    }
                })
            }

        }
    }



    return (
        <>
            {compLoader ? <Loader /> : (
            <div className="create-basket-parent" style={{
                ...( !(!curBlockData || curBlockData?.bannerVersion) && { backgroundColor: 'transparent' })
              }}>
                {(!curBlockData || curBlockData?.bannerVersion) &&
                <>
                <div className="create-basket-label">
                    <span>PROMO BLOCK</span>
                </div>
                <div className='create-block-input-fields'>
                    {/* <div style={{display:"flex", justifyContent:"end"}}>
                    {redirectToRef && <button style={{display:"flex",width:"fit-content",alignItems:"center",flexDirection:"row",gap:"15px"}} className="manage-home-screen-create-new create-block-input-fields" onClick={()=>{
               redirectToRef.current = "banner";
               setOpenCreateModal(true)   
                }}>
                    <FontAwesomeIcon
                    fontSize={15}
                    icon={faPlus}
                />
                Create Banner
            </button>}
                    </div> */}
                    <div className="create-bucket-primary-types-row">
                        <GenricMultiSelect
                            className="create-bucket-primary-type-multi-select"
                            options={bannerOptions}
                            label={""}
                            selectedOptions={selectedBanners}
                            handleMultiSelectState={handleSelectBanners}
                            isRequired={false}
                            params={{ size: "small" }}
                        />
                        <FontAwesomeIcon
                            onClick={handleAddBanners}
                            className="create-bucket-plus-icon"
                            icon={faCirclePlus}
                        />
                    </div>
                    <BannerPreview openBannerPreview={openBannerPreview} setOpenBannerPreview={setOpenBannerPreview} bannerElements={currentBannerElements} />
                    {banners?.length > 0 && <DragDropContext onDragEnd={handleDragOnEnd}>
                        <Droppable droppableId="droppableNeedBasedBanners">
                            {(provided) => (
                                <div className="create-bucket-need-based-banners-container" {...provided.droppableProps}
                                    ref={provided.innerRef}>
                                    {
                                        banners.map((bannerObj: Banner, index: number) => {
                                            return (
                                                <Draggable
                                                    key={bannerObj.bannerName}
                                                    draggableId={bannerObj.bannerName}
                                                    index={index}
                                                >
                                                    {(provided) => (
                                                        <div className='card' ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
                                                            <div className="item_card" >
                                                                <span>
                                                                    <FontAwesomeIcon className='transfer_list_grip_lines_icon' icon={faGripLines} />
                                                                    {bannerObj.bannerName}
                                                                </span>
                                                                <span className='homepage_icon_container'>
                                                                    <span onClick={() => handleEye(bannerObj)}>
                                                                        <FontAwesomeIcon color={"#a48034"} icon={faEye} />
                                                                    </span>
                                                                    {view !== "create" && <span><FontAwesomeIcon color={"#2596be"} icon={faArrowUpRightFromSquare} onClick={() => {
                                                                        targetBanner.current = bannerObj as Banner;
                                                                        setOpenConfirmModal(true)
                                                                    }} /></span>}
                                                                    <span style={{ display: "flex", alignItems: "center" }} onClick={() => {
                                                                        setOpenDeleteConfirmModal(true);
                                                                        deleteBanner.current = bannerObj
                                                                    }}>
                                                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" stroke="#b84444" stroke-width="1.8" width="16" height="16" className="bi bi-dash-circle" viewBox="0 0 16 16">
                                                                            <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14z" />
                                                                            <path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8z" />
                                                                        </svg>

                                                                        {/* <FontAwesomeIcon color={"#b84444"} icon={faCircleMinus} /> */}
                                                                    </span>
                                                                </span>
                                                            </div>

                                                        </div>
                                                    )}

                                                </Draggable>
                                            )
                                        })
                                    }
                                    {provided.placeholder}
                                </div>
                            )}
                        </Droppable>
                    </DragDropContext>}
                </div>
                </> }
                <button
                    className="create-basket-submit create-basket-submit-active"
                    onClick={() => { setOpenSubmitModal(true) }}
                >
                    {showLoader ? (
                        <div>
                            <CircularProgress size={15} color="inherit" />
                            <span className="circular-progress-container ">SUBMIT</span>
                        </div>
                    ) : (
                        <>SUBMIT</>
                    )}
                </button>

                <ConfirmationPopUp message="Are you sure you want to save?"
                    openConfirmModal={openSubmitModal}
                    setOpenConfirmModal={setOpenSubmitModal}
                    successMethod={handleSubmit}/>

                <ConfirmationPopUp message="Are you sure you want to create bucket?"
                    openConfirmModal={openCreateModal}
                    setOpenConfirmModal={setOpenCreateModal}
                    successMethod={handleSubmit} />

                <ConfirmationPopUp
                    openConfirmModal={openConfirmModal}
                    setOpenConfirmModal={setOpenConfirmModal}
                    message={"You may have unsaved changes, Are you sure you want to navigate?"}
                    successMethod={navigateToEditBanner}
                />
                <ConfirmationPopUp
                    openConfirmModal={openDeletConfirmModal}
                    setOpenConfirmModal={setOpenDeleteConfirmModal}
                    message={"Are you sure you want to delete banner?"}
                    successMethod={handleBannerRemove}
                />
                <ConfirmationPopUp message="Are you sure you want to create banner?"
                    openConfirmModal={openCreateModal}
                    setOpenConfirmModal={setOpenCreateModal}
                    successMethod={handleSubmit} />
            </div>)}

        </>
    )
}
